import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StatusBadgeComponent } from './status-badge.component';

@NgModule({
  entryComponents: [
    StatusBadgeComponent
  ],
  imports: [
    CommonModule
  ],
  declarations: [
    StatusBadgeComponent
  ],
  exports: [
    StatusBadgeComponent
  ]
})
export class StatusBadgeModule {}
